import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
const extras = [{
  name: 'Engine Bay Top',
  price: '$120'
}, {
  name: 'Headlight Restore',
  price: '$80'
}, {
  name: 'Clay Bar Treatment',
  price: '$60'
}, {
  name: 'Water Spots / Dog Hair',
  price: 'Call for Pricing'
}];
export function Extras() {
  return <section className="w-full bg-black py-12 px-4 border-t border-zinc-900" id="extras" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <div className="relative bg-zinc-900/50 border border-red-900/30 rounded-xl p-8 md:p-12 overflow-hidden" data-id="element-108">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-109" />

          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10" data-id="element-110">
            <div data-id="element-111">
              <h3 className="text-3xl md:text-4xl font-black uppercase text-white mb-2" data-id="element-112">
                <span className="text-red-600" data-id="element-113">Extra</span> Services
              </h3>
              <p className="text-gray-400 text-lg" data-id="element-114">
                Add these to any package for the ultimate finish
              </p>
            </div>
            <div className="p-3 bg-red-600/10 rounded-full" data-id="element-115">
              <Plus className="w-8 h-8 text-red-500" data-id="element-116" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-117">
            {extras.map((extra, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center justify-between p-4 bg-black/40 border border-zinc-800 rounded-lg hover:border-red-900/50 transition-colors" data-id="element-118">
                <span className="font-bold text-gray-200 uppercase tracking-wide text-lg" data-id="element-119">
                  {extra.name}
                </span>
                <span className="font-black text-red-500 text-xl" data-id="element-120">
                  {extra.price}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}